import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HighlightCardComponent } from '../../../highlight-card/highlight-card.component';
import { IconComponent } from '../../../icon/icon.component';
import { Article } from './models/article.type';

@Component({
    selector: 'nw-knowledge-centre-selection-block',
    imports: [HighlightCardComponent, IconComponent],
    templateUrl: './knowledge-centre-selection-block.component.html',
    styleUrl: './knowledge-centre-selection-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KnowledgeCentreSelectionBlockComponent {
    @Input() articles!: Article[];
    @Input() title: string = 'From our Knowledge Centre';
}
